import { render, staticRenderFns } from "./Opiniones.vue?vue&type=template&id=294cba82&"
import script from "./Opiniones.vue?vue&type=script&lang=js&"
export * from "./Opiniones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports